import { observable } from 'mobx';
import { AgendamentoModel } from '../Agendamento';
import { AlunoModel } from '../Aluno';
import { DepositoModel } from '../Deposito';
import { MembroDaBancaModel } from '../Banca/Model';
import { ProfessorModel } from '../Professor';

export class MonografiaModel {
  readonly id: number = 0;
  @observable public titulo: string = '';
  @observable public justificativa: string = '';
  @observable public desenvolvimento: string = '';
  @observable public bibliografia: string = '';
  @observable public dataDeApresentacaoSugerida?: Date = undefined;
  @observable public deposito?: DepositoModel = undefined;
  @observable public aluno: AlunoModel = new AlunoModel();
  @observable public agendamento?: AgendamentoModel;
  @observable public professor: ProfessorModel = new ProfessorModel();
  @observable public banca: Array<MembroDaBancaModel> = [];
  @observable public palavrasChave: Array<PalavrasChave> = [];
  @observable public nota?: number = undefined;
  @observable public notaOrientador?: number = undefined;
  @observable public notaConvidado?: number = undefined;
  @observable public observacao?: string = '';
  @observable public autorizacaoAluno?: boolean = undefined;
  @observable public autorizacaoProfessor?: boolean = undefined;
}

export class PalavrasChave {
  readonly id: number = 0;
  @observable public monografiaId: number = 0;
  @observable public palavraChave: string = '';
}